<template>
  <div class="mt-8">
     <StickyHScroll>
    <v-data-table-server
      v-model:options="pagination"
      :headers="headers"
      :items="users"
      :items-length="totalItems"
      :items-per-page="pagination.itemsPerPage"
      :items-per-page-options="[
        { value: 5, title: '5' },
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' },
      ]"
      items-per-page-text="Rows per page"
      item-value="_id"
      return-object
      :loading="loading"
      class="elevation-1 nowrap-headers pb-8"
      @update:options="updatePagination"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #item="{ item, index }">
        <tr>
          <td>
            <v-chip
              v-if="item.status === 'Approved'"
              color="success"
              label
              variant="outlined"
            >
              {{ $t("leko_employees.approve_users.table.approved") }}
            </v-chip>
            <v-chip
              v-if="item.status === 'Refused'"
              color="error"
              label
              variant="outlined"
            >
              {{ $t("leko_employees.approve_users.table.refused") }}
            </v-chip>
            <v-chip
              v-if="item.status === 'Waiting Approval'"
              color="orange"
              label
              variant="outlined"
            >
              {{ $t("leko_employees.approve_users.table.waiting_approval") }}
            </v-chip>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.surname }}</td>
          <td>
            <v-chip>{{ item.email }}</v-chip>
          </td>
          <td>{{ item.address }}</td>
          <td>{{ item.phone }}</td>
          <td>
            <v-row class="ma-2">
              <img
                :src="
                  item.photo
                    ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/images/id-photos?q=${item._id}-${
                        item.photo
                      }&date=${item.date}`
                    : `https://portal.lekotech.com/logo_small.png`
                "
                height="75"
                width="100"
                @click="
                  showImage({
                    filename: `${item._id}-${item.photo}`,
                    date: item.date,
                  })
                "
              />
            </v-row>
          </td>
          <td>
            <v-row class="d-flex flex-nowrap text-truncate">
              <v-btn
                :disabled="item.status === 'Approved'"
                variant="text"
                icon
                @click="approveUser(item._id)"
              >
                <v-icon color="grey-darken-2"> mdi-check </v-icon>
              </v-btn>
              <v-btn
                :disabled="item.status === 'Refused'"
                variant="text"
                icon
                @click="refuseUser(item._id)"
              >
                <v-icon color="grey-darken-2"> mdi-broom </v-icon>
              </v-btn>
              <v-btn variant="text" icon @click="deleteUser(item._id)">
                <v-icon color="grey-darken-2"> mdi-delete </v-icon>
              </v-btn>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table-server>
      </StickyHScroll>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";

export default {
  props: ["search"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    loading: false,
    users: [],
    totalItems: 0,
    pagination: {
      itemsPerPage: 5,
      page: 1,
      groupBy: ["date"],
      sortBy: { key: "date", order: "desc" },
      sortDesc: [true],
    },
    currentRowData: {
      index: 0,
      discount: 0,
      savedDiscount: false,
    },
    discountRule: [(v) => (v >= 0 && v < 100) || "Invalid value"],
    headers: [
      {
        title: "Status",
        sortable: true,
        key: "status",
      },
      {
        title: "Name",
        sortable: true,
        key: "name",
      },
      {
        title: "Surname",
        sortable: true,
        key: "surname",
      },
      {
        title: "Email",
        sortable: true,
        key: "email",
      },
      {
        title: "Address",
        sortable: true,
        key: "address",
      },
      {
        title: "Phone",
        sortable: true,
        key: "phone",
      },
      {
        title: "Photo",
        sortable: false,
        key: "photo",
      },
      {
        title: "Actions",
        sortable: false,
        key: "actions",
      },
    ],
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    searchObject() {
      return this.$props.search;
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.searchObject.type === null) {
          this.getUsers();
        } else if (this.searchObject.type === "regularSearch") {
          this.regularSearch(this.searchObject.data);
        } else if (this.searchObject.type === "advancedSearch") {
          this.advancedSearch(
            this.searchObject.data.searchField,
            this.searchObject.data.advancedSearchFields,
          );
        } else {
          //
        }
      },
      deep: true,
    },
    searchObject: {
      handler(value) {
        if (value.type === null) {
          this.getUsers();
        } else if (value.type === "regularSearch") {
          this.regularSearch(value.data);
        } else if (value.type === "advancedSearch") {
          this.advancedSearch(
            value.data.searchField,
            value.data.advancedSearchFields,
          );
        } else {
          //
        }
      },
    },
  },
  beforeMount() {
    this.getUsers();
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.headers[0].title = this.$t(
        "leko_employees.approve_users.table.status",
      );
      this.headers[1].title = this.$t(
        "leko_employees.approve_users.table.name",
      );
      this.headers[2].title = this.$t(
        "leko_employees.approve_users.table.surname",
      );
      this.headers[3].title = this.$t(
        "leko_employees.approve_users.table.email",
      );
      this.headers[4].title = this.$t(
        "leko_employees.approve_users.table.address",
      );
      this.headers[5].title = this.$t(
        "leko_employees.approve_users.table.phone",
      );
      this.headers[6].title = this.$t(
        "leko_employees.approve_users.table.photo",
      );
      this.headers[7].title = this.$t(
        "leko_employees.approve_users.table.actions",
      );
    },
    getUsers() {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date",
        order: "desc",
      };
      getRequest(
        "/user/shop/all",
        `&limit=${this.pagination.itemsPerPage}&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
      )
        .then((response) => {
          this.users = response.users;
          this.totalItems = response.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    regularSearch(data) {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date",
        order: "desc",
      };
      getRequest(
        "/user/shop/search/regular",
        `search=${data.searchField}&limit=${
          this.pagination.itemsPerPage
        }&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
      )
        .then((response) => {
          this.users = response.users;
          this.totalItems = response.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    advancedSearch(searchField, advancedSearchFields) {
      this.loading = true;
      const sort = this.pagination.sortBy?.[0] || {
        key: "date",
        order: "desc",
      };
      getRequest(
        "/user/shop/search/advanced",
        `search=${searchField}&status=${advancedSearchFields.status}&limit=${
          this.pagination.itemsPerPage
        }&page=${
          this.pagination.page
        }&sort_by=${sort.key}&descending=${sort.order === "desc"}`,
      )
        .then((response) => {
          this.users = response.users;
          this.totalItems = response.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    approveUser(id) {
      this.$emit("approve-user", id);
    },
    refuseUser(id) {
      this.$emit("refuse-user", id);
    },
    deleteUser(id) {
      this.$emit("delete-user", id);
    },
    showImage(data) {
      this.$emit("image-dialog", data);
    },
    updatePagination(options) {
      this.pagination = {
        ...options,
        itemsPerPage: options.itemsPerPage ? options.itemsPerPage : 5,
        groupBy:
          options.groupBy && options.groupBy.length
            ? options.groupBy
            : ["date"],
        sortBy:
          options.sortBy && options.sortBy.length
            ? options.sortBy
            : { key: "date", order: "desc" },
        sortDesc:
          options.sortDesc && options.sortDesc.length
            ? options.sortDesc
            : [true],
      };
      this.activeRow = null;
    },
  },
};
</script>
